<template>
  <div>
    <el-dialog 
      title="Create Rule" 
      :before-close="handleClose" 
      :show-close="false" 
      :visible.sync="visible">    

      <rule :rule="rule" :campaign="campaign" ></rule>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" v-if="rule.events" @click="addEmptyAction">Add Action</el-button>
        <el-button size="small" @click="handleClose">Cancel</el-button>
        <el-button size="small" type="primary" @click="handleSave(rule)">Save Rule</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Rule from '@/components/rules/Rule';
import ruleMixins from '../../mixins/rules';

export default {
  name: 'RuleCreate',
  components: { Rule },
  mixins: [ruleMixins],
  data: () => ({
    rule: {
      title: null,
      events: null,
      campaign: 1,
      actions: [],
      conditions: [],
    },
  }),
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    campaign() {
      return this.$route.params.campaignId;
    },
  },
  methods: {
    handleSave(rule) {
      this.$store.dispatch('rules/createRule', rule);
    },
  },
};
</script>


// WEBPACK FOOTER //
// RuleCreate.vue?3984f722